module.exports = __webpack_public_path__ + "static/media/empty-state-trips.4fcd64e1.svg";